import { Component, EventEmitter, Input, OnChanges, OnInit, Output, output, SimpleChanges } from '@angular/core';
import { CommonService, UserService } from '../../../../services/common';
import { AddressType, UserSubType } from '../../../../../appconfig';
import { AcquisitionService } from '../../acquisition.service';
import { environment } from '../../../../../environments/environment';
import { IconList } from '../../../../../iconlist';

@Component({
  selector: 'app-farmer-details',
  templateUrl: './farmer-details.component.html',
  styleUrl: './farmer-details.component.scss'
})
export class FarmerDetailsComponent implements OnInit, OnChanges {
  @Input() farmer: any;
  @Output() khasraClicked: EventEmitter<any> = new EventEmitter<any>();
  currentFarmerData: any;
  userProfileImage: any = environment.assetsImagePath + IconList.DefaultUserProfilePic;;
  currentFarmerKhasras: any
  groupedKhasras: any;

  constructor(public commonService: CommonService, private userService: UserService, private acquisitionService: AcquisitionService) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Initialize farmer data or fetch from a service
    this.getUserData();
  }

  /**
   * Fetches user data for the current farmer.
   * It retrieves the farmer's details and processes their addresses.
   * If the farmer has khasras, it fetches them as well.
   */
  getUserData() {
    this.userService.getFilterUser(null, null, UserSubType.Farmer, this.farmer?.id).subscribe((res: any) => {
      this.currentFarmerData = null;
      if (res != null) {
        this.currentFarmerData = res?.result?.map((data: any) => {
          data.farmerName = data?.nameInitial?.name + '.' + ' ' + data?.firstName + ' ' + data?.lastName;
          if (data?.addresses?.length > 0) {
            data?.addresses?.forEach((addr: any) => {
              const type = addr?.assressType?.name?.toLowerCase();

              if (type == (AddressType.Current.toString().toLowerCase())) {
                data.currentAddress = addr;
              } else if (AddressType.Permanent.toString().toLowerCase()) {
                data.permanentAddress = addr;
              } else if (AddressType.Firm.toString().toLowerCase()) {
                data.firmAddress = addr;
              }
              return data;
            })
          }
          return data;
        });

        if (Array.isArray(this.currentFarmerData) && this.currentFarmerData.length > 0) {
          this.currentFarmerData = this.currentFarmerData[0];
        }

        // if (this.farmer?.id) {
        //   const id = Number(this.farmer?.id);
        //   this.acquisitionService.getFarmerById(id).subscribe(data => {
        //     const currentFarmerKhasras = data;
        //   })
        // }

        this.getKhasraofFamrer(this.currentFarmerData);
      }
    });
  }


  /**
   * Gets khasras for the current farmer and groups them by landKhata.
   * @param currentFarmerData - The data of the current farmer.
   */
  getKhasraofFamrer(currentFarmerData: any) {
    this.acquisitionService.filterKhasra(null, null, null, null, currentFarmerData?.id).subscribe(data => {
      // Step 1: Filter khasras where current farmer is part of it
      this.currentFarmerKhasras = data.filter((khasra: any) =>
        khasra.farmers.some((farmer: any) => farmer?.id === currentFarmerData?.id)
      );

      this.groupedKhasras = [];

      // Step 2: Group khasras by landKhata and include farmer's individual payment
      this.currentFarmerKhasras.forEach((khasra: any) => {
        const khataId = khasra.landKhata?.id;
        if (!khataId) return;

        // Step 3: Get individual payment by current farmer from `amounts`
        const farmerUserId = currentFarmerData?.id;
        const paymentByFarmer = khasra.amounts
          ?.filter((amt: any) => amt.account?.userId === farmerUserId)
          ?.reduce((sum: number, amt: any) => sum + (parseFloat(amt.amountValue) || 0), 0);

        // Step 4: Check if group for landKhata already exists
        const existingGroup = this.groupedKhasras.find((group: any) => group?.landKhata?.id === khataId);

        // Step 5: Push khasra into group
        if (existingGroup) {
          existingGroup.khasra.push({ ...khasra, paymentToCurrentFarmer: paymentByFarmer });
        } else {
          this.groupedKhasras.push({
            landKhata: khasra.landKhata,
            khasra: [{ ...khasra, paymentToCurrentFarmer: paymentByFarmer }],
            totalArea: 0,
          });
        }
      });

      // Step 6: Calculate totalArea for each grouped khata
      this.groupedKhasras.forEach((group: any) => {
        group.totalArea = parseFloat(
          group.khasra.reduce((sum: number, k: any) => sum + (parseFloat(k?.area) || 0), 0).toFixed(2)
        );
      });
    });
  }

  /**
   * opens a modal to view khasra details.
   * @param currentKhasra current khasra whose details are to be viewed
   */
  openKhasraModal(currentKhasra: any) {
    this.khasraClicked.emit({ khasra: currentKhasra });
  }
}
